import React, {useEffect, useState} from 'react';
import {
    Avatar,
    Button,
    IconButton,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import DeleteIcon from "@mui/icons-material/Delete";
import {deleteTriggerApi, switchTriggerApi} from "../api/triggersApi";
import dayjs from "dayjs";
import {Box} from "@mui/system";

const API_URL = process.env.REACT_APP_API_URL || window.API_URL;

export default function TriggerList({triggers, onEdit, reload, clinic}) {
    const [clinicOffset, setClinicOffset] = useState(null);

    useEffect(() => {
        if (clinic?.timezoneOffset) {
            setClinicOffset(-parseInt(clinic.timezoneOffset));
        }
    }, [clinic]);

    if (!triggers || triggers.length === 0) {
        return <p>Список триггеров пуст</p>;
    }

    const handleDelete = async (id) => {
        if (!window.confirm('Вы уверены, что хотите удалить этот триггер?')) return;

        try {
            await deleteTriggerApi(id);
            await reload();
            // Обновить список после удаления — зависит от того, как у тебя устроен стейт
            // Если данные из родителя или useEffect с API — вызови повторный запрос
            // Или фильтруй локально:
            // setTriggers((prev) => prev.filter((t) => t.id !== id));
        } catch (err) {
            alert('Ошибка при удалении: ' + err.message);
        }
    };

    const handleToggle = async (trigger) => {
        try {
            await switchTriggerApi(trigger.id, !trigger.isActive);
            await reload();
        } catch (err) {
            alert('Ошибка при обновлении статуса: ' + err.message);
        }
    };

    return (
        <TableContainer component={Paper} sx={{marginTop: 2}}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width: 150}}>Дата создания</TableCell>
                        <TableCell sx={{width: 80}}>Превью</TableCell>
                        <TableCell sx={{minWidth: 250}}>
                            Заголовок (только для вас) + Текст сообщения
                        </TableCell>
                        <TableCell sx={{width: 100}}>Бонусы</TableCell>
                        <TableCell sx={{width: 100}}>Активен</TableCell>
                        <TableCell sx={{width: 160}}>Действия</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {triggers.map((trigger) => (
                        <TableRow key={trigger.id}>
                            <TableCell>
                                {dayjs
                                    .utc(trigger.createdAt)
                                    .add(clinicOffset, 'minute')
                                    .format('DD.MM.YYYY HH:mm')}
                            </TableCell>

                            <TableCell>
                                {trigger.imageName ? (
                                    <Avatar
                                        src={`${API_URL}/static/${trigger.imageName}`}
                                        alt="Превью"
                                        variant="square"
                                        sx={{width: 64, height: 64}}
                                    />
                                ) : (
                                    <Avatar variant="square" sx={{width: 64, height: 64}}>
                                        N/A
                                    </Avatar>
                                )}
                            </TableCell>

                            <TableCell sx={{minWidth: 250}}>
                                <Box>
                                    <Box
                                        component="div"
                                        sx={{
                                            fontWeight: 'bold',
                                            fontSize: '1rem',
                                            color: 'primary.main',
                                            mb: 0.5,
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                        title={trigger.title}
                                    >
                                        {trigger.title}
                                    </Box>

                                    <Box
                                        component="div"
                                        sx={{
                                            fontSize: '0.875rem',
                                            whiteSpace: 'normal', // Позволяет тексту переноситься
                                            overflow: 'visible', // Убирает скрытие текста
                                            textOverflow: 'clip', // Убирает многоточие
                                            wordBreak: 'break-word', // Переносит длинные слова
                                        }}
                                        title={trigger.templateText}
                                    >
                                        {trigger.templateText}
                                    </Box>
                                </Box>
                            </TableCell>

                            <TableCell>
                                {trigger.type === 'SURVEY_AFTER_APPOINTMENT' ? '—' : (trigger.pointsCount || 0)}
                            </TableCell>

                            <TableCell>
                                <Switch
                                    checked={trigger.isActive || false}
                                    onChange={() => handleToggle(trigger)}
                                    color="primary"
                                    inputProps={{'aria-label': 'активность триггера'}}
                                />
                            </TableCell>

                            <TableCell>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => onEdit(trigger)}
                                    sx={{mr: 1}}
                                >
                                    Редактировать
                                </Button>
                                <IconButton color="error" onClick={() => handleDelete(trigger.id)}>
                                    <DeleteIcon/>
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}